import { makeUrl } from "../utils/urls";
import { getApi, postApi } from "./apiCalls";

export const getOrders = (page = 1) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`riders/orders`);
    getApi(url, { page: page }, true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getClothPriceList = () => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`orders/price-list`);
    getApi(url, {}, true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const markAsComplete = (orderId) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`riders/orders/${orderId}/complete-delivery`);
    postApi(url, {}, "post", true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateClothAndPriceListForOrder = (orderId, clothes_list) => {
  const data = {
    clothes_and_prices: {
      ...clothes_list,
    },
  };

  return new Promise((resolve, reject) => {
    const url = makeUrl(`riders/orders/${orderId}/add-cloth-details`);
    postApi(url, data, "post", true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const completeDelivery = (orderId, payment_mode = 1) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`riders/orders/${orderId}/complete-delivery`);
    postApi(url, { payment_mode: payment_mode }, "post", true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const placeOrder = (customerId, addressData) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`riders/customers/${customerId}/orders`);
    postApi(url, { ...addressData }, "post", true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const markOrderUrgent = (orderId, preferred_datetime = null) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`riders/orders/${orderId}/mark-urgent`);
    const payload = {};
    if (preferred_datetime) {
      payload.preferred_datetime = preferred_datetime;
    }
    postApi(url, payload, "post", true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const markOrderNotUrgent = (orderId) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`riders/orders/${orderId}/remove-urgent`);
    postApi(url, {}, "post", true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const checkOnlinePaymentStatusOfOrder = (orderId) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`riders/orders/${orderId}/online-payment-status-check`);
    postApi(url, {}, "post", true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const generateQr = (orderId) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`riders/orders/${orderId}/fetch-qr`);
    postApi(url, {}, "post", true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getTotalAmountOfOrder = (orderId) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`riders/orders/${orderId}/total-amount`);
    getApi(url, {}, true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const getRacksForOrder = (orderId) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`packets_assignments/orders/${orderId}/cells-list`);
    getApi(url, {}, true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

export const updateNotAddressedReason = (
  orderId,
  reason,
  preferredDateTime = null
) => {
  return new Promise((resolve, reject) => {
    const url = makeUrl(`riders/orders/${orderId}/not-addressed-reason-update`);
    const payload = { reason: reason };

    if (preferredDateTime) {
      payload.preferred_datetime = preferredDateTime;
    }

    postApi(url, payload, "post", true)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};
